import { render, staticRenderFns } from "./loadingScan.vue?vue&type=template&id=fa0cbdde&scoped=true"
import script from "./loadingScan.vue?vue&type=script&lang=js"
export * from "./loadingScan.vue?vue&type=script&lang=js"
import style0 from "./loadingScan.vue?vue&type=style&index=0&id=fa0cbdde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0cbdde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa0cbdde')) {
      api.createRecord('fa0cbdde', component.options)
    } else {
      api.reload('fa0cbdde', component.options)
    }
    module.hot.accept("./loadingScan.vue?vue&type=template&id=fa0cbdde&scoped=true", function () {
      api.rerender('fa0cbdde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/carScan/loadingScan.vue"
export default component.exports